// :cow: Cosmose CONFIDENTIAL :iso:

import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { userRestored } from '@med/app/auth/store/auth.actions';
import { decodeToken } from '@med/app/core/utils/decode-token';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(
    private store$: Store,
  ) {
  }

  canActivate(): boolean | Observable<boolean> {
    const accessToken = localStorage.getItem('access_token');
    const refreshToken = localStorage.getItem('refresh_token');
    if (accessToken && refreshToken) {
      this.store$.dispatch(userRestored({profileDto: decodeToken(accessToken)}));
    }
    return true;
  }

}
